import React from "react";
import "./style.css";

const PriceCard = (props) => {
  return (
    <div className="priceCardContainer">
      <img
        src={props.src}
        alt={props.alt}
        style={
          window.innerWidth > 600
            ? { width: "200px", height: "170px" }
            : { width: "100px", height: "85px" }
        }
      />
      <div>
        <h3>{props.price}</h3>
        <p style={window.innerWidth > 600 ? {} : { textAlign: "center" }}>
          {props.note}
        </p>
      </div>
    </div>
  );
};

export default PriceCard;
